import {jessicaMainInteractions} from "../interactions/jessica/main";
import {sofiaMainInteractions} from "../interactions/sofia/main";
import {SofiaEvents} from "../events/sofia.events";
import {SamanthaEvents} from "../events/samantha.events";
import {
    samanthaBasicInteractions,
    samanthaSexInteractions,
    samanthaWaifuInteractions
} from "../interactions/samantha/main";
import {
    elenHomeInteractions,
    elenMainInteractions,
    elenPreJobInteractions,
    elenSexInteractions
} from "../interactions/elen/main";
import {anastasiaDateInteractions, anastasiaMainInteractions} from "../interactions/anastasia/main";
import {AnastasiaEvents} from "../events/anastasia.events";
import {
    lisaHomeDatesInteractions,
    lisaHomeInteractions,
    lisaHomeSexInteractions,
    lisaMainInteractions
} from "../interactions/lisa/main";
import {vickyDateInteractions, vickyMainInteractions} from "../interactions/vicky/main";
import {VickyEvents} from "../events/vicky.events";
import {seleneMainInteractions} from "../interactions/selene/main";

export class InteractionsService {
    _interactions = [];
    _selectedOption = -1;

    windowSize = 3;

    set selectedOption(option) {
        this._selectedOption = option;
    }

    get selectedOption() {
        return this._selectedOption;
    }

    getInteractions() {
        return this._interactions;
    }

    setWindowSmall() {
        this.windowSize = 4;
    }

    setWindowMedium() {
        this.windowSize = 3;
    }

    setWindowLarge() {
        this.windowSize = 2;
    }

    buildJessicaInteractions() {
        this.setWindowSmall();
        jessicaMainInteractions.find((interaction) => interaction.id === 3).disabled = !JessicaEvents.hasActiveEvent();
        const jessicaInteractions = jessicaMainInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...jessicaInteractions, {id: 0, label: 'Nevermind', disabled: false}];
    }

    buildSofiaInteractions() {
        this.setWindowSmall();
        const sofiaInteractions = [...sofiaMainInteractions];
        sofiaInteractions.find((interaction) => interaction.id === 1).disabled = SofiaEvents.isFirstEvent();
        sofiaInteractions.find((interaction) => interaction.id === 2).disabled = !SofiaEvents.hasActiveEvent() && !SofiaEvents.isFirstEvent()
        sofiaInteractions.find((interaction) => interaction.id === 3).disabled = !EventStateService.sofiaSecondEvent;

        const filteredInteractions = sofiaInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: 'Nevermind', disabled: false}];
    }

    buildSamanthaInteractions() {
        const samanthaInteractions = (SamanthaEvents.isWaifu()) ? [...samanthaWaifuInteractions] : [...samanthaBasicInteractions];

        samanthaInteractions.find((interaction) => interaction.id === 1).disabled = !SamanthaEvents.hasActiveEvent();

        const filteredInteractions = samanthaInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: 'Nevermind', disabled: false}];
    }

    buildSamanthaSexInteractions() {
        const samanthaInteractions = [...samanthaSexInteractions];
        const filteredInteractions = samanthaInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: 'Nevermind', disabled: false}];
    }

    buildElenInteractions() {
        const elenInteractions = ($gameSwitches.value(1)) ? [...elenMainInteractions] : [...elenPreJobInteractions];

        if($gameSwitches.value(1)) {
            elenInteractions.find((interaction) => interaction.id === 5).disabled = !ElenEvents.hasActiveEvent();
        }

        const filteredInteractions = elenInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "I'm just looking around for now.", disabled: false}];
    }

    buildElenHomeInteractions() {
        const elenInteractions = [...elenHomeInteractions];

        elenInteractions.find((interaction) => interaction.id === 7).disabled = !ElenEvents.hasActiveEventHomeEvent();
        elenInteractions.find((interaction) => interaction.id === 8).disabled = false;

        const filteredInteractions = elenInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "Nevermind", disabled: false}];
    }

    buildElenHomeSexInteractions() {
        const elenInteractions = [...elenSexInteractions];

        const filteredInteractions = elenInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "Nevermind", disabled: false}];
    }

    buildAnastasiaInteractions() {
        const anastasiaInteractions = [...anastasiaMainInteractions];

        anastasiaInteractions.map((interaction) => {
            if(interaction.id === 2) {
                interaction.disabled = !Yosemite.EventStateManager.anastasiaFirstTalk
            }

            if(interaction.id === 3) {
                interaction.disabled = YsServices.questService.status(YsServices.questService.questEnum.RubinaGymTip) !== YsServices.questService.statusEnum.Completed;
            }

            if(interaction.id === 4) {
                interaction.disabled = !Yosemite.EventStateManager.anastasiaFirstSexEvent;
            }

            if(interaction.id === 5) {
                interaction.disabled = !AnastasiaEvents.hasActiveEvent();
            }
        });

        const filteredInteractions = anastasiaInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "See you later", disabled: false}];
    }

    buildAnastasiaDateInteractions() {
        const anastasiaInteractions = [...anastasiaDateInteractions];
        const filteredInteractions = anastasiaInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "See you later", disabled: false}];
    }

    buildLisaInteractions() {
        const lisaInteractions = [...lisaMainInteractions];

        lisaInteractions.map((interaction) => {
            if(interaction.id === 2) {
                interaction.disabled = !EventStateService.lisaFirstEvent
            }

            if(interaction.id === 3) {
                interaction.disabled = !LisaEvents.hasActiveEvent();
            }
        });

        const filteredInteractions = lisaInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "Nevermind", disabled: false}];
    }

    buildLisaHomeInteractions() {
        const lisaInteractions = [...lisaHomeInteractions];

        lisaInteractions.map((interaction) => {
            if(interaction.id === 7) {
                interaction.disabled = !EventStateService.lisaBreakdown;
            }

            if(interaction.id === 6) {
                interaction.disabled = !EventStateService.lisaBeachMeeting;
            }
        });

        const filteredInteractions = lisaInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "Nevermind", disabled: false}];
    }

    buildLisaHomeSexInteractions() {
        const lisaInteractions = [...lisaHomeSexInteractions];

        const filteredInteractions = lisaInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "Nevermind", disabled: false}];
    }

    buildLisaHomeDateInteractions() {
        const lisaInteractions = [...lisaHomeDatesInteractions];

        lisaInteractions.map((interaction) => {
            if(interaction.id === 9) {
                interaction.disabled = !EventStateService.lisaBreakdown;
            }

            if(interaction.id === 12) {
                interaction.disabled = !EventStateService.lisaMeetingElenInPark;
            }
        });

        const filteredInteractions = lisaInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "Nevermind", disabled: false}];
    }

    buildVickyInteractions() {
        const vickyInteractions = [...vickyMainInteractions];

        vickyInteractions.map((interaction) => {
            if(interaction.id === 2) {
                interaction.disabled = !Yosemite.EventStateManager.state.gym.vicky.jogging;
            }

            // if(interaction.id === 3) {
            //     interaction.disabled = !VickyEvents.isWaifu();
            // }

            if(interaction.id === 4) {
                interaction.disabled = !VickyEvents.hasActiveEvent();
            }
        });

        const filteredInteractions = vickyInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "Nevermind", disabled: false}];
    }

    buildVickyDateInteractions() {
        const vickyInteractions = [...vickyDateInteractions];

        vickyInteractions.map((interaction) => {
            if(interaction.id === 6) {
                interaction.disabled = !Yosemite.EventStateManager.state.gym.vicky.training;
            }

            if(interaction.id === 7) {
                interaction.disabled = !Yosemite.EventStateManager.state.gym.vicky.beach;
            }
        });

        const filteredInteractions = vickyInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "Nevermind", disabled: false}];
    }

    buildSeleneInteractions() {
        const seleneInteractions = [...seleneMainInteractions];

        seleneInteractions.map((interaction) => {
            if(interaction.id === 2) {
                interaction.disabled = !SeleneEvents.hasActiveEvent();
            }
        });

        const filteredInteractions = seleneInteractions.filter((interaction) => !interaction.disabled);
        this._interactions = [...filteredInteractions, {id: 0, label: "Nevermind", disabled: false}];
    }
}
